import { UserRole, useRouter } from '@mi-front/core';
import React from 'react';
import { useIntl } from 'react-intl';
import { CanByRole } from '../auth/authorization';
import { useToast } from '../notifications';
import { noPermissionMessage } from './AppRoute';

/**
 * Wraps route content in a role guard. When the user's role is not allowed,
 * redirects to '/' and shows a warning toast.
 */

export function AuthorizedRouteContent({
  allowedRole,
  content,
}: {
  allowedRole: UserRole | UserRole[];
  content: React.ReactNode;
}) {
  const { history } = useRouter();
  const { notifyWarn } = useToast();
  const { $t } = useIntl();

  return (
    <CanByRole
      role={allowedRole}
      cant={() => {
        history.push('/');
        notifyWarn($t(noPermissionMessage));
        return null;
      }}
    >
      {content}
    </CanByRole>
  );
}
